<div class="card">
  <div class="card-header">
    <span class="card-title"
      >{{ currentMeterUnit.id ? "Edit " : "Add " }} Meter Unit</span
    >
  </div>
  <div class="card-body">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input
        matInput
        [(ngModel)]="currentMeterUnit.name"
        [disabled]="!(adding || modifying) || selected"
        name="name"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input
        matInput
        [(ngModel)]="currentMeterUnit.description"
        [disabled]="!(adding || modifying)"
        name="description"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select
        [(ngModel)]="currentMeterUnit.status"
        [disabled]="!(adding || modifying) || disabledStatus"
        name="status"
      >
        <mat-option *ngFor="let RCstatus of statusList" [value]="RCstatus.id">
          {{ RCstatus.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button color="warn" (click)="onNoClick()">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="disabledTimer"
        (click)="saveMeterUnit()"
      >
        Accept
      </button>
    </div>
  </div>
</div>
